import { createSlice } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import { initialState } from './initState';
import { PERSIST_KEYS, STORE_SLICES } from '../../utils/enums';

import { reducers } from './reducers';

export const slice = createSlice({
  name: STORE_SLICES.ORDERS,
  initialState,
  reducers,
});

const ordersActions = slice.actions;

const ordersPersistConfig = {
  key: PERSIST_KEYS.ORDERS,
  storage,
  whitelist: ['dailyStateSelectedLocation', 'dailyStatesData', 'selectedOrder'],
};

export {
  ordersActions,
};

export default persistReducer(ordersPersistConfig, slice.reducer);
